module.exports = __webpack_public_path__ + "34bc775d/img/settings-icon.121d9519.svg";